import { PermissionsService } from '../../services/permissions/permissions.service';
import { CustomerSelectPopupComponent } from '../customer-select-popup/customer-select-popup.component';
import { Customer } from '../../dto/customer';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  AfterViewInit,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { Directionality } from '@angular/cdk/bidi';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'pcp-customer-select',
    templateUrl: './customer-select.component.html',
    styleUrls: ['./customer-select.component.scss'],
    imports: [NgIf, MatButton]
})
export class CustomerSelectComponent implements OnInit, OnDestroy {
  constructor(
    public dialog: MatDialog,
    private permissions: PermissionsService,
    private dir: Directionality,
    private cd: ChangeDetectorRef
  ) {}

  @Input()
  value: string | null = null;
  @Input()
  disabled = false;
  private selectCustomerText = $localize`Select Customer`;
  @Input()
  customers: Customer[] | null = null;

  @Output()
  valueChange = new EventEmitter<string>();
  onDestroy$ = new Subject<void>();
  get customerName() {
    if (this.customers && this.value) {
      const customer = this.customers.find((c) => c.id === this.value);
      if (customer) {
        return customer.name;
      }
    }
    return this.selectCustomerText;
  }
  ngOnInit() {
    if (!this.customers || this.customers.length === 0) {
      this.permissions.allCustomers$
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((si) => {
          this.customers = si;
          this.cd.detectChanges();
        });
    }
  }
  ngOnDestroy() {
    this.onDestroy$.next();
  }

  selectCustomer() {
    let selected: Customer | null = null;
    if (this.customers && this.value) {
      selected = this.customers.find((c) => c.id === this.value) || null;
    }
    const data = {
      customers: this.customers,
      selected: selected
    };
    this.dialog
      .open(CustomerSelectPopupComponent, {
        direction: this.dir.value,
        data: data
      })
      .afterClosed()
      .pipe(take(1), takeUntil(this.onDestroy$))
      .subscribe((result: Customer) => {
        if (result) {
          this.value = result.id;
          this.valueChange.emit(result.id);
        }
      });
  }
}
